import { Button, Grid, Modal, Space } from "antd";
import type { ReactNode } from "react";
import { CustomDrawer } from "./layout/workspace/custom-drawer";

interface ResponsiveDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: ReactNode;
	children: ReactNode;
	footer?: ReactNode;
	onOk?: () => void;
	onCancel?: () => void;
	okText?: string;
	cancelText?: string;
	/** Desktop modal width; the mobile drawer is unaffected. */
	width?: number;
}

/** Shows a Modal on desktop and a bottom Drawer on mobile. */
export function ResponsiveDialog({
	open,
	onOpenChange,
	title,
	children,
	footer,
	onOk,
	onCancel,
	okText = "OK",
	cancelText = "Cancel",
	width = 600,
}: ResponsiveDialogProps) {
	const screens = Grid.useBreakpoint();
	const isMobile = !screens.md;

	const handleCancel = () => {
		onCancel?.();
		onOpenChange(false);
	};

	const resolvedFooter =
		footer ??
		(onOk || onCancel ? (
			<Space>
				<Button onClick={handleCancel}>{cancelText}</Button>
				<Button type="primary" onClick={onOk}>
					{okText}
				</Button>
			</Space>
		) : null);

	if (isMobile) {
		return (
			<CustomDrawer
				open={open}
				onClose={handleCancel}
				placement="bottom"
				title={title}
				// height="90vh"
				footer={resolvedFooter}
			>
				{children}
			</CustomDrawer>
		);
	}

	return (
		<Modal
			open={open}
			onCancel={handleCancel}
			title={title}
			width={width}
			footer={resolvedFooter}
			styles={{ body: { overflowY: "auto", maxHeight: "70vh" } }}
		>
			{children}
		</Modal>
	);
}
